import { atom } from 'jotai'

const global = atom({
  mobile: false,
  tablet: false,
  lg: false
})

export default global
